let _ = require("ES/lib/lodash");
let dd = require("ES/lib/dd");
let radio = require("ES/lib/react-pubsub-via-radio.js/radio");
let Modal = require("ES/widgets/Modal");
let esUtils = require("ES/utils/esUtils");
let FormMixin = require("react-loose-forms");
let dateformat = require("ES/lib/dateformat");
let ErrorAlert = require("ES/widgets/ErrorAlert");
let RadioMixin = require("ES/lib/react-pubsub-via-radio.js/RadioMixin");
let LoadingWrap = require("ES/widgets/LoadingWrap");
let FormButtons = require("react-loose-forms.bootstrap3/layouts/FormButtons");
let ezHorizontalFields = require("react-loose-forms.bootstrap3/layouts/ezHorizontalFields");

let getCoworkersFromEvent = function (event) {
  let usernames = [];
  _.forEach(_.get(event, "CoWorkers", []), function (a, speaker_id) {
    usernames.push(a);
  });
  usernames = _.flattenDeep(usernames);
  usernames = _.uniq(usernames, function (n) {
    return _.get(n, "id", "").toUpperCase();
  });
  return usernames;
};

let DaForm = dd.createClass({
  mixins: [FormMixin],
  getInitialValuesSourceVersion({event}) {
    return esUtils.getEventVersionIdentifier(event);
  },
  getInitialValues({event}) {
    if (event && event.eid > 0) {
      let subject = "Event";
      if (!esUtils.isBlank(event.organization)) {
        subject += " for " + event.organization;
      }
      if (_.isDate(event.starttime)) {
        subject += " on " + dateformat(event.starttime, "mmm d, yyyy");
      }
      return {subject};
    }
    return {};
  },
  buildSchema() {
    let {coworkers} = this.props;
    let schema = {};
    _.each(coworkers, function (name, id) {
      schema["coworker_" + id] = {
        label: name,
        type: "checkbox"
      };
    });
    schema.subject = {
      label: "Subject",
      type: "text"
    };
    schema.note = {
      label: "Note",
      type: "textarea"
    };
    schema.email = {
      label: "Additional Email(s)",
      type: "text",
      help_text: 'Additional email addresses to send to (comma separated)'
    };
    return schema;
  },
  render() {
    let {onCancel} = this.props;
    var fields = this.Form_buildSchema();

    var checkboxes = [];
    _.each(fields, function (field) {
      if (field.type == 'checkbox') {
        checkboxes.push([field.name]);
      }
    });
    var inputs = [
      ['email'],
      ['subject'],
      ['note']
    ];

    return dd.form({className: "form-horizontal", onSubmit: this.Form_onSubmit},
      dd.div({style: {marginBottom: '15px', maxHeight: '295px', overflowY: 'auto'}},
        ezHorizontalFields(this, checkboxes)
      ),
      ezHorizontalFields(this, inputs),
      dd.br(),
      FormButtons({submit_btn_text: "Send", onCancel, right_align: true})
    );
  }
});

let DaModal = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {loading: false, error_msg: null};
  },
  Radio_setup() {
    return {
      email_Event_to_coworkers(event_id) {
        if (event_id === this.props.event.eid) {
          this.setState({loading: true, error_msg: null});
        }
      },
      email_Event_to_coworkers_succeeded(event_id) {
        if (event_id === this.props.event.eid) {
          this.props.onClose();
        }
      },
      email_Event_to_coworkers_failed(event_id, message) {
        if (event_id === this.props.event.eid) {
          this.setState({loading: false, error_msg: "Failed to send email: " + message});
        }
      }
    };
  },
  __onSubmit(data) {
    let users = _.map(_.filter(_.pairs(data), function (pair) {
      return /^coworker_/.test(pair[0]) && pair[1] === true;
    }), function (pair) {
      return pair[0].replace(/^coworker_/, "");
    });
    if (users.length === 0) {
      this.setState({error_msg: "You must select at least one co-worker to email this to."});
      return;
    }
    radio("email_Event_to_coworkers").broadcast(this.props.event.eid, users, data.subject, data.note, data.email);
  },
  render() {
    let {event, onClose} = this.props;
    let coworkers = getCoworkersFromEvent(event);
    coworkers = _.map(coworkers, function (coworker) {
      return [_.get(coworker, "id"), _.get(coworker, "name", _.get(coworker, "id"))]; //.name isn't included where the list is long, so just re-use the login id
    });
    coworkers = _.sortBy(coworkers, function (n) {
      return _.get(n, [1]);
    });
    coworkers = _.object(coworkers);

    if (this.state.loading) {
      return Modal({title: "Sending...", buttons: []}, LoadingWrap({text: "Sending...", is_loading: true}));
    }
    return Modal({
        title: "Email to Co-workers",
        buttons: [],
        onClose
      },
      ErrorAlert({message: this.state.error_msg}),
      DaForm({
        event,
        coworkers,
        onSubmit: this.__onSubmit,
        onCancel: onClose
      })
    );
  }
});

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState() {
    return {event_to_email: null, showing_prompt_to_use_email: false};
  },
  Radio_setup() {
    return {
      event_schedule_change(event) {
        let {Displaylists} = this.props;
        let preferences = _.get(Displaylists, "user.myevents_preferences", {});

        if (_.size(getCoworkersFromEvent(event)) <= 1) {
          return;//don't notify if there is only one user for this event
        }
        if (_.get(preferences, "notify_coworkers_on_schedule_changes")) {
          this.setState({event_to_email: event, showing_prompt_to_use_email: true});
        }
      },
      send_event_to_coworkers(event) {
        let self = this;
        setTimeout(function () {
          self.setState({event_to_email: event});
        }, 10);
      }
    };
  },
  __close: esUtils.wrapPreventDefault(function () {
    this.setState({event_to_email: null});
  }),
  __togglePromptWindow: esUtils.wrapPreventDefault(function () {
    this.setState({showing_prompt_to_use_email: !this.state.showing_prompt_to_use_email});
  }),
  render() {
    let event = this.state.event_to_email;
    let {Displaylists} = this.props;
    if (_.isEmpty(event) || _.isEmpty(Displaylists)) {
      return dd.div();
    }
    if (this.state.showing_prompt_to_use_email) {
      return Modal({
          title: "Notify co-workers?",
          buttons: [],
          onClose: this.__close
        },
        dd.div({className: "row"},
          dd.div({className: "col-sm-3 text-center text-muted"},
            dd.i({className: "fa fa-users", style: {fontSize: 60}})
          ),
          dd.div({className: "col-sm-9"},
            dd.p(null,
              "Would you like to notify your co-workers of your schedule change to the event?"
            )
          )
        ),
        dd.div({className: "text-center"},
          dd.button({className: "btn btn-primary", onClick: this.__togglePromptWindow}, "Yes, notify"),
          " ",
          dd.button({className: "btn btn-default", onClick: this.__close}, "No thanks")
        )
      );
    }
    return DaModal({event, Displaylists, onClose: this.__close});
  }
});


// WEBPACK FOOTER //
// ./src/components/modals/EmailToCoworkers.js